<crm-single-select
  [options]="methodTypes"
  [(selectedItem)]="documentMethod"
  (selectedItemChange)="documentMethodChange.emit($event)"
  class="w-full {{ isError ? 'ng-invalid ng-dirty' : '' }}"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  optionValue="name"
  [showClear]="showClear"
  [isTemplateCombined]="true"
  [filter]="false"
  [disabled]="disabled"
  [appendTo]="appendTo">
  <ng-template
    #itemTemplate
    let-type="item">
    {{ type.value | documentCalculationMethodName }}
  </ng-template>
</crm-single-select>
